export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.deployNotice.expectedEnd': 'Expected end',
  'component.scrollToTop.label': 'Back to top',
  'component.couponStockAlert.title': 'Coupon out of stock — checkout failed',
  'component.couponStockAlert.member': 'Member',
  'component.couponStockAlert.coupon': 'Coupon',
  'component.couponStockAlert.remaining': 'Remaining',
  'component.couponStockAlert.products': 'Products',
  'component.couponStockAlert.orderTotal': 'Order total',
  'component.couponStockAlert.attempts': '{count} attempts',
  'component.couponStockAlert.andMore': '+{count} more',
  'component.couponStockAlert.action': 'Raise the issued quantity or close the coupon. The member could not pay.',
  // 자사몰 상품 피커(OwnMallProductPickerModal) 공용 문구
  'component.productPicker.title': 'Register Company Mall Products',
  'component.productPicker.confirm': 'Add Selected ({count})',
  'component.productPicker.searchPlaceholder': 'Search by name / OfferId / UniqueNo',
  'component.productPicker.loadFailed': 'Failed to load products.',
  'component.productPicker.noneSelected': 'Select at least one product to add.',
  'component.productPicker.allStores': 'All stores',
  'component.productPicker.totalProducts': '{total} in total',
  'component.productPicker.columns.image': 'Image',
  'component.productPicker.columns.title': 'Product',
  'component.productPicker.columns.productNo': 'Product No.',
  'component.productPicker.columns.uniqueNo': 'UniqueNo',
  'component.productPicker.columns.salePrice': 'Sale Price',
  // 자사몰 상품 상세 팝업(OwnMallProductDetailModal) 공용 문구
  'component.ownMallProductDetail.title': 'Company Mall Product Detail',
  'component.ownMallProductDetail.notFound': 'Product not found.',
  'component.ownMallProductDetail.loadFailed': 'Failed to load the product.',
  'component.ownMallProductDetail.field.titleKo': 'Name (Korean)',
  'component.ownMallProductDetail.field.titleEn': 'Name (English)',
  'component.ownMallProductDetail.field.titleZh': 'Name (Chinese)',
  'component.ownMallProductDetail.field.productNo': 'Product No.',
  'component.ownMallProductDetail.field.uniqueNo': 'UniqueNo',
  'component.ownMallProductDetail.field.offerId': 'OfferId',
  'component.ownMallProductDetail.field.companyName': 'Shop',
  'component.ownMallProductDetail.field.salesStatus': 'Sales status',
  'component.ownMallProductDetail.field.displayStatus': 'Display status',
  'component.ownMallProductDetail.field.flags': 'Badges',
  'component.ownMallProductDetail.field.costPrice': 'Cost',
  'component.ownMallProductDetail.field.salePrice': 'Sale price',
  'component.ownMallProductDetail.field.tagPrice': 'Tag price',
  'component.ownMallProductDetail.field.marginRate': 'Margin',
  'component.ownMallProductDetail.field.stock': 'Stock',
  'component.ownMallProductDetail.field.createdAt': 'Registered',
  'component.ownMallProductDetail.status.onSale': 'On sale',
  'component.ownMallProductDetail.status.offSale': 'Off sale',
  'component.ownMallProductDetail.status.soldOut': 'Sold out',
  'component.ownMallProductDetail.status.stopped': 'Stopped',
  'component.ownMallProductDetail.status.draft': 'Draft',
  'component.ownMallProductDetail.display.visible': 'Visible',
  'component.ownMallProductDetail.display.hidden': 'Hidden',
  'component.ownMallProductDetail.flag.popular': 'Popular',
  'component.ownMallProductDetail.flag.featured': 'Featured',
  'component.ownMallProductDetail.flag.newArrival': 'New',
  'component.ownMallProductDetail.flag.bestSeller': 'Best',
  'component.ownMallProductDetail.sku.title': 'Price & stock by option',
  'component.ownMallProductDetail.sku.image': 'Image',
  'component.ownMallProductDetail.sku.option': 'Option',
  'component.ownMallProductDetail.sku.noOption': 'No option',
  'component.ownMallProductDetail.sku.empty': 'No options registered.',
  'component.ownMallProductDetail.action.openStorefront': 'View on storefront',
  'component.ownMallProductDetail.action.edit': 'Go to edit page',
};
